import { EdContextMenuOptionsModel } from '../../plugins/ed-context-menu/ed-context-menu.plugin';
import { COURSE_EVENTS } from '../values/events';
import { SECTION_TYPES, SECTION_OPTIONS, SECTIONS_TYPE_FILE, SECTION_OPTIONS_TEACHER, SECTION_OPTIONS_CONTENT } from '../values/sections';
import { MULTIMEDIA_FILES_TYPES_EXT } from '@/courses/values/courses.values'
import { EVENT_BUS } from '@/content/values/events';
import KEYS from '../../values/keys';
import Content from '../models/content.model';
import Tools from '@/providers/tools';
import { Section } from '@/courses/models/section.model';

class SectionProvider {

  getSectionById(sections = [], sectionId = 0) {
    let found = null;
    sections.forEach((s, i) => {
      if(s.sectionId == sectionId) {
        found = {value: s, i: i, j: null};
        return;
      } else {
        let sub = this.getSectionById(s.sections, sectionId);
        if(sub) {
          found = {value: sub.value, i: i, j: sub.i};
        }          
      }
    });
    return found;
  }

  getSectionByID(sections = [], sectionId = 0): Section {
    let found = null;
    sections.forEach(s => {
      if(s.sectionId == sectionId || s.id == sectionId) {
        found = s;
      } else if(s.sections.length > 0 && s.type == SECTION_TYPES.SECTION.code) {
        let section = this.getSectionByID(s.sections, sectionId);
        found = section ? section : found;
      }
    });
    return found;
  }

  getDeckLibraryByID(sections = [], id = 0): Section {
    let found = sections.find(s => s.id == id );
    return found;
  }

  updateSubdeckObjectsByDeck(sections , deck) {
    return sections.map(s => {
      if(deck && s.type === 'SUBDECK' ? JSON.parse(s.text)?.deck === deck.id : false) {
        return {...s, component: deck.component};
      } else if(s.sections.length > 0) {
        return {...s , sections: this.updateSubdeckObjectsByDeck(s.sections, deck)};
      }
      return {...s};
    }); 
  }

  addSection(sections = [], section = {}, parentId = null, copiedSectionId = -1) {
    if(parentId) {
      return sections.map(s => {
        if(s.sectionId == parentId) {
          if(copiedSectionId == -1)
            s.sections.push(section);
          else{
            let pos = -1;
            s.sections.map((s,i) => {
              if(s.sectionId == copiedSectionId)
                pos = i
            });
            s.sections.splice(pos+1,0,section);
          }
          return {...s};
        } else if(s.sections.length > 0 && s.type == SECTION_TYPES.SECTION.code) {
          return {...s, sections: this.addSection(s.sections, section, parentId)};
        }
        return {...s};
      }); 
    } else {
      sections.push(section);
      return sections;
    }
  }

  updateSection({sections = [], section, courseId , classId}) {
    return sections.map(s => {
      if(section && s.sectionId == section.id) {
        if(!section.sections) {
          section.sections = [];
        } 
        return {...section , courseId , classId , sectionId: section.id};
      } else if(s.sections.length > 0) {
        return {...s , courseId , classId , sections: this.updateSection({sections: s.sections, 
        section , courseId , classId})};
      }
      return {...s, courseId , classId};
    }); 
  }

  /* Subject Projects */
  updateSectionProject({projects = [], section, courseId , classId}){
    return projects.map(s => {
      if(section && s.section?.id == section.id) {
        return {...s, section, courseId, classId};
      } else if(s.projects.length > 0) {
        return {...s, projects: this.updateSectionProject({projects: s.projects, 
        section , courseId , classId})};
      }
      return {...s};
    }); 
  }

  removeSectionProject(list = [], sectionId = 0) {
    let sectionIndex = null;
    list.forEach((s, i) => {
      if(s.section?.id == sectionId) {
        sectionIndex = i;
      } else {
        if(s.projects.length > 0) {
          s.projects = this.removeSectionProject(s.projects, sectionId); 
        }
      }
    });
    if(sectionIndex !== null) {
      list.splice(sectionIndex, 1);
    }
    return list;
  }

  getProjectByID(projects = [], projectId = 0) {
    let found = null;
    projects.forEach(s => {
      if(s.projectId == projectId) {
        found = s;
      } else if(s.projects.length > 0 && s.type == SECTION_TYPES.PROJECT.code) {
        let project = this.getProjectByID(s.projects, projectId);
        found = project ? project : found;
      }
    });
    return found;
  }

  addProjectSection({ projects = [], project = {}, parentId = null }) {
    if(parentId) {
      return projects.map(s => {
        if(s.projectId == parentId) {
          s.projects.push(project);
          return {...s};
        } else if(s.projects.length > 0 && s.type == SECTION_TYPES.PROJECT.code) {
          return {...s, projects: this.addProjectSection({projects: s.projects, project, parentId})};
        }
        return {...s};
      }); 
    } else {
      projects.push(project);
      return projects;
    }
  }

  updateProject({ projects = [], project, courseId, classId }) {
    return projects.map(s => {
      if(project && s.projectId == project.projectId) {
        if(!project.projects) {
          project.projects = [];
        } 
        return {...project , courseId , classId , projectId: project.projectId};
      } else if(s.projects.length > 0) {
        return {...s , courseId , classId , projects: this.updateProject({projects: s.projects, 
          project , courseId , classId})};
      }
      return {...s, courseId , classId};
    }); 
  }

  setCourseProjects({projects, parentId = 0 , courseId , classId = null}) {
    return projects.map(item => {
      if(item.projects?.length > 0) {
        return {...item, classId , courseId , projectId:item.projectId, 
          projects: this.setCourseProjects({projects: item.projects, parentId: item.projectId , courseId , classId}),
          resolved: item.hasBeenResolvedByAnyStudent };
      } else {
        if(item.section?.sectionMaterial && item.section?.sectionMaterial.id){
          item.section.sectionMaterial =  { 
            ...item.section.sectionMaterial,
            data: new Content({...item.section.sectionMaterial.materialAssetInfo}),
          }
        }
        if(item.section?.sections.length > 0){
          item.section.sections = item.section?.sections.map(el => {
            if(el.sectionMaterial) {
              return {...el, 
                sectionMaterial: { 
                  ...el.sectionMaterial, 
                  data: new Content({...el.sectionMaterial.materialAssetInfo})
                }}
            } else return el
          })
        }
        return {...item, classId , courseId , projectId:item.projectId, projects: [], parentId };
      }
    });
  }

  removeProject(list = [], projectId = 0) {
    let projectIndex = null;
    list.forEach((s, i) => {
      if(s.projectId == projectId) {
        projectIndex = i;
      } else {
        if(s.projects.length > 0) {
          s.projects = this.removeProject(s.projects, projectId); 
        }
      }
    });
    if(projectIndex !== null) {
      list.splice(projectIndex, 1);
    }
    return list;
  }

  assignProjectsToSection(list = [], projects = [], projectId = 0) {
    return list.map(s => {
      if(s.projectId == projectId) {
        return {...s, projects: projects };
      } else if(s.projects.length > 0) {
        return {...s , projects: this.assignProjectsToSection(s.projects, projects, projectId)};  
      }
      return {...s};
    });
  }

  getProjectsIdsByMaterialId(projects = [], materialId) {
    let projectsIds = [];
    function findProjectsMaterial(projects = [], materialId) {
      projects.forEach(sec => {
        if(sec.section?.sectionMaterial && sec.section?.sectionMaterial.materialId == materialId) {
            projectsIds.push(sec.projectId);
            if(sec.section?.sections.length > 0) {
              findMaterialInSubSections(sec, materialId);
            }
        } else if (sec.section?.sections.length > 0) {
          findMaterialInSubSections(sec, materialId);
        } else if(sec.projects.length > 0) {
          findProjectsMaterial(sec.projects, materialId);
        }
      });
    }
    function findMaterialInSubSections(project, materialId) {
      project.section.sections.forEach(el => {
        if(el.sectionMaterial && el.sectionMaterial.materialId == materialId) {
          projectsIds.push(project.projectId);
        }
      })
    }
    findProjectsMaterial(projects , materialId);
    return projectsIds;
  }
  /* End Subject Projects */

  updateMaterialSection(nodes = [], section: any = {}){
    return nodes.map(node => {
      if(node.sectionId == section.sectionId) {
        return {...section};
      } else if(node.nodes.length > 0) {
        return {...node , nodes: this.updateMaterialSection(node.nodes, section)};
      }
      return {...node};
    }); 
  }

  assignSectionsToSection(list = [], sections = [], sectionId = 0) {
    return list.map(s => {
      if(s.sectionId == sectionId) {
        return {...s, sections: sections };
      } else if(s.sections.length > 0) {
        return {...s , sections: this.assignSectionsToSection(s.sections, sections, sectionId)};  
      }
      return {...s};
    });
  }

  removeSection(list = [], sectionId = 0) {
    let sectionIndex = null;
    list.forEach((s, i) => {
      if(s.sectionId == sectionId) {
        sectionIndex = i;
      } else {
        if(s.sections.length > 0) {
          s.sections = this.removeSection(s.sections, sectionId); 
        }
      }
    });
    if(sectionIndex !== null) {
      list.splice(sectionIndex, 1);
    }
    return list;
  }
  
  getEditSectionMenu(i18n = { t: (a?) => {}})  {
    return [
      new EdContextMenuOptionsModel({
        id: 1,
        text: i18n.t('common.edit'),
        type: COURSE_EVENTS.EDIT_SECTION,
        borderBottom: true
      }),
      new EdContextMenuOptionsModel({
        id: 2,
        text: i18n.t('common.remove'),
        type: COURSE_EVENTS.REMOVE_SECTION,
        borderBottom: true
      })
    ]
  }

  getCreateObjectMenuTeacher(i18n = { t: () => {}}, hasCourseMaterialOption = false, canCreateLesson = false) {
    let menu = this.getCreateObjMenu(SECTION_OPTIONS_TEACHER, i18n);
    if(!hasCourseMaterialOption) {
      menu = menu.filter(m => m.type != 'courseMaterial');
    }
    if(!canCreateLesson) {
      menu = menu.filter(m => m.type != 'lesson');
    }
    return menu;
  }

  getCreateObjectMenuContent(i18n = { t: () => {}}) {
    let menu = this.getCreateObjMenu(SECTION_OPTIONS_CONTENT, i18n);
    return menu;
  }

  getCreateObjectMenu(i18n = { t: () => {}}) {
    return this.getCreateObjMenu(SECTION_OPTIONS, i18n);
  }

  getCreateObjMenu(options: any = SECTION_OPTIONS, i18n = { t: (a?) => {}}) {
    options.forEach(o => {
      o.text = i18n.t(`common.${o.type}`);
      o.borderBottom = true;
    });
    return options;
  }

  setCourseContent({parentSections, sections, parentId = 0 , courseId , classId = null}) {
    return sections.map(item => {
      if (item) {
        if (item.sections.length > 0) {
          if(item.fixedSection ===  SECTION_TYPES.SECTION_LINK.code) {
            return new Section({
              ...item,
              classId,
              courseId,
              sections: this.setCourseContent({
                parentSections,
                sections:  item.sections.map(el => { let sectionId = el.type === SECTION_TYPES.SECTION.code ? Math.floor(Math.random() * 1000000) : el.id;
                    return { ... el, id: sectionId, sectionId, fixedSection: item.fixedSection }}),
                parentId: item.id,
                courseId,
                classId
              })
            });
          }

          return new Section({
            ...item,
            classId,
            courseId,
            sections: this.setCourseContent({
              parentSections,
              sections: item.sections,
              parentId: item.id,
              courseId,
              classId
            })
          });
        } else {
          if (item.type == SECTION_TYPES.SECTION_LINK.code) {
            let copySection = this.getSectionByID(parentSections, JSON.parse(item.text).target);
            return new Section({
              ...item,
              classId,
              courseId,
              sectionId: item.id,
              name: copySection.name,
              sections: this.setCourseContent({
                parentSections,
                sections: copySection.sections.map(el => { let sectionId = el.type === 'SECTION' ? Math.floor(Math.random() * 1000000) : el.id;
                          return { ... el, id: sectionId, sectionId, fixedSection: item.type }}),
                parentId: item.id,
                courseId,
                classId,
              }),
              parentId,
              fixedSection: copySection.fixedSection,
              fixedSequence: copySection.fixedSequence
            })
          }
          
          if (item.sectionMaterial && item.sectionMaterial.id) {
            item.sectionMaterial = { 
              ...item.sectionMaterial,
              data: new Content({
                ...item.sectionMaterial.materialAssetInfo, 
                contentFileUrl:item.sectionMaterial.materialAssetInfo.url
              })
            };
          }

          return new Section({...item, classId , courseId , sectionId:item.id, sections: [], parentId });
        }
      }  
    });
  }

  getExtensionFromSectionType(type) {
    let extension = '';
    switch (type) {
      case SECTION_TYPES.LESSON_EPUB.code:
      case SECTION_TYPES.LESSON_MATERIAL.code:
      case SECTION_TYPES.LESSON_PDF.code:
      case SECTION_TYPES.SPLIT_QUESTION_PDF.code:
      case SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code:
      case SECTION_TYPES.SPLIT_SOLUTION_PDF.code:
      case SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code:
      case SECTION_TYPES.LESSON_TEXT.code:
        extension = KEYS.FILES_TYPE.PDF;
        break;
      case SECTION_TYPES.LESSON_DOCX.code:
        extension = KEYS.FILES_TYPE.DOCX;
        break;
      case SECTION_TYPES.LESSON_DOC.code:
        extension = KEYS.FILES_TYPE.DOC;
        break;
      case SECTION_TYPES.LESSON_XLSX.code:
        extension = KEYS.FILES_TYPE.XLSX;
        break;
      case SECTION_TYPES.LESSON_XLS.code:
        extension = KEYS.FILES_TYPE.XLS;
        break;
      case SECTION_TYPES.LESSON_PPTX.code:
        extension = KEYS.FILES_TYPE.PPTX;
        break;
      case SECTION_TYPES.LESSON_PPT.code:
        extension = KEYS.FILES_TYPE.PPT;
        break;
    }
    return extension.toLowerCase();
  }

  getParamsToSaveSection(titleModal, courseId, parentId, id, sectionType, sectionName, isEdit = false, classId) {
    let modalTitleSectionType = SECTIONS_TYPE_FILE.filter((sectionT) => sectionT != SECTION_TYPES.LESSON_IMAGES.code).some((sectionT) => sectionT == sectionType) ? SECTION_TYPES.LESSON_TEMP_FILE.code : sectionType;
    let titleModalV = `${titleModal} ${Tools.camelCaseToString(SECTION_OPTIONS_TEACHER.find((sectionF) => sectionF.code == modalTitleSectionType).type)}`;
    let params: any = {
      objId: !isEdit ? null : id,
      courseId,
      classId,
      parentId,
      modalBusSaveEvent: EVENT_BUS.SAVE_CREATE_MODAL,
      titleModal: titleModalV,
      type: sectionType
    }
    if(SECTIONS_TYPE_FILE.some(fileType => fileType == sectionType)){
      let dropOptions: any = {
        url: !isEdit ? `content/upload/${courseId}/section/${parentId}/object` : `content/upload/${courseId}/structure/${id}`,
        autoProcessQueue: isEdit,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxFiles: 1,
        parallelUploads: 1,
        paramName: 'file',
        createImageThumbnails: false,
        timeout: 600000
      }
      if(SECTIONS_TYPE_FILE.filter(fileType => fileType != SECTION_TYPES.LESSON_IMAGES.code).some(fileType => fileType == sectionType)){
        dropOptions.acceptedFiles = 'application/pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt';
        dropOptions.maxFilesize = 200;
      }else{
        dropOptions.acceptedFiles = 'image/png,.jpg,.jpeg';
        dropOptions.parallelUploads = 2;
      }
      if(!isEdit){
        params.modalBusSaveEvent = `${EVENT_BUS.CREATE_OBJECT_FILE}`;
      }
      params.requestDataName = 'section';
      params.dropOptions = dropOptions;
    } else {
      if(!isEdit){
        params.modalBusSaveEvent = `${EVENT_BUS.CREATE_OBJECT_NO_FILE}`;
      }
    }
    return params;
  }

  getCourseIndex({state , courseId, classId}) {
    let ICourse = state.courses.content.findIndex(course => {
      if(classId) return course.id == courseId && course.classId == classId;
      else return course.id == courseId;
    });
    return ICourse;
  }

  /* Course materials methods */
  setCourseMaterials({materials , state , courseId , classId}) {
    return {...materials ,courseId , classId ,materials: materials.materials.length > 0 ? 
      this.setCourseMaterialsContent({materials: materials.materials , state , courseId , classId}) : [] ,
      nodes: materials.nodes.length > 0 ? 
      this.setCourseMaterialsSections({sections: materials.nodes , state , courseId , classId}) : []
    }
  }

  setCourseMaterialsSections({sections , state , courseId , classId}) {
    return sections.map(item => {
      let materialData = {materials: item.materials , state , courseId , classId}
      if(item.nodes) {
        return {...item , courseId , classId ,materials: this.setCourseMaterialsContent(materialData) , 
                nodes: this.setCourseMaterialsSections({sections: item.nodes , state , courseId , classId}) }
      } else {
        return {...item , courseId , classId , materials: this.setCourseMaterialsContent(materialData) , nodes: []}
      }
    });
  }

  setCourseMaterialsContent({materials , state , courseId , classId}) {
    return materials.map(item => {
      item.relatedContentResponse.imported = item.relatedContentResponse.id ? item.relatedContentResponse.imported : true;      
      this.setCourseMaterialOptionUsed(state, item.relatedContentResponse.id);
        return {
          classId,
          courseId,
          data: new Content({...item.relatedContentResponse,type: KEYS.CONTENT_TYPE.BK}, state.url),
          relatedContentId: item.id,
          sectionParentId: item.sectionMaterialId ? item.sectionMaterialId : null,
          component: item.component
        }
     });
  }

  setCourseMaterialOption(materials) {
    return materials.map(item => {
      return {
        data: new Content({...item , type: KEYS.CONTENT_TYPE.BK}, KEYS.CONTEXT),
        id: item.id
      }
    });
  }

  setCourseMaterialOptionUsed(state , id) {
    let alreadyIn = id && state.materialsOptionsUsed ? state.materialsOptionsUsed.includes(id) : true;
    if(!alreadyIn) {
      state.materialsOptionsUsed.push(id);
    }
  }

  addCourseMaterial({state , materials, material, courseId, classId}) {
    material.relatedContentResponse.imported = material.relatedContentResponse.id ? material.relatedContentResponse.imported : true;
    let newMaterial = { 
      component: material.component,
      data: new Content({...material.relatedContentResponse, type: KEYS.CONTENT_TYPE.BK}, state.url), classId , courseId ,
      relatedContentId: material.id, sectionParentId: material.sectionMaterialId ? material.sectionMaterialId : null 
    }
    if(!newMaterial.sectionParentId) {
      materials.materials.push(newMaterial);
      return materials;
    }
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach(sec => {
        if(sec.sectionId == sectionId) {
          sec.materials.push(newMaterial);
        } else {
          findSectionsMaterial(sec.nodes , sectionId);
        }
      });
    }
    findSectionsMaterial(materials.nodes , newMaterial.sectionParentId);
    return materials;  
  }

  addCourseMaterialList({state , materialsList, material, courseId, classId}) {
    material.relatedContentResponse.imported = material.relatedContentResponse.id ? material.relatedContentResponse.imported : true;
    let newMaterial = { 
      component: material.component,
      data: new Content({...material.relatedContentResponse, type: KEYS.CONTENT_TYPE.BK}, state.url), classId , courseId ,
      relatedContentId: material.id, sectionParentId: material.sectionMaterialId ? material.sectionMaterialId : null,
      materialsList: []
    }
    if(!newMaterial.sectionParentId) {
      materialsList.push(newMaterial);
      return materialsList;
    }
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach(sec => {
        if(sec.sectionId == sectionId) {
          sec.materialsList.push(newMaterial);
        } else {
          if(sec.materialsList.length > 0)
            findSectionsMaterial(sec.materialsList , sectionId);
        }
      });
    }
    findSectionsMaterial(materialsList , newMaterial.sectionParentId);
    return materialsList;  
  }

  addCourseMaterialSection({materials , section , courseId , classId}) {
    let newSection = { courseId , classId,
    materials: [] , nodes: [] , parentId: section.parentId,
    sectionId: section.id , sectionName: section.name , teacherOnly: false }
    if(!section.parentId) {
      materials.nodes.push(newSection);
      return materials;
    }
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach(sec => {
        if(sec.sectionId == sectionId) {
          sec.nodes.push(newSection);
        } else {
          findSectionsMaterial(sec.nodes , sectionId);
        }
      });
    }
    findSectionsMaterial(materials.nodes , section.parentId);
    return materials;
  }

  addCourseMaterialListSection({materialsList , section , courseId , classId}) {
    let newSection = { courseId , classId,
      materials: [] , nodes: [] , materialsList: [], parentId: section.parentId,
      sectionId: section.id , sectionName: section.name , teacherOnly: false }
      if(!section.parentId) {
        materialsList.push(newSection);
        return materialsList;
      }
      function findSectionsMaterial(sections = [], sectionId) {
        sections.forEach(sec => {
          if(sec.sectionId == sectionId) {
            sec.materialsList.push(newSection);
          } else {
            findSectionsMaterial(sec.materialsList , sectionId);
          }
        });
      }
      findSectionsMaterial(materialsList , section.parentId);
      return materialsList;
  }

  updateCourseMaterial({state , materials , material , courseId , classId}) {
    material.relatedContentResponse.imported = material.relatedContentResponse.id ? material.relatedContentResponse.imported : true;
    let newMaterial = {
      component: material.component,
      data: new Content({...material.relatedContentResponse, type: KEYS.CONTENT_TYPE.BK}, state.url),
      courseId,
      classId, 
      relatedContentId: material.id,
      sectionParentId: material.sectionMaterialId ? material.sectionMaterialId : null,
      materialsList: []
    }
    function findByID(materials , materialId) {
      let index = materials.materials.findIndex( material =>  material.relatedContentId === materialId);
      if(index >= 0) {        
        materials.materials.splice(index , 1 , newMaterial);
      } else {
        materials.nodes.forEach( sec => findByID(sec , materialId ));        
      }
    }
    findByID(materials , material.id);
    return materials;
  }

  updateCourseMaterialList({state , materialsList , material , courseId , classId}) {
    material.relatedContentResponse.imported = material.relatedContentResponse.id ? material.relatedContentResponse.imported : true;
    let newMaterial = {
      component: material.component,
      data: new Content({...material.relatedContentResponse, type: KEYS.CONTENT_TYPE.BK}, state.url),
      courseId,
      classId, 
      relatedContentId: material.id,
      sectionParentId: material.sectionMaterialId ? material.sectionMaterialId : null,
      materialsList: [] 
    }
    function findByID(materialsList , materialId) {
      let index = materialsList.findIndex( material =>  material.relatedContentId === materialId);
      if(index >= 0) {        
        materialsList.splice(index , 1 , newMaterial);
      } else {
        materialsList.forEach( sec => {
          if(sec.materialsList.length > 0)
            findByID(sec.materialsList , materialId )
        });
      }
    }
    findByID(materialsList , material.id);
    return materialsList;
  }

  removeCourseMaterial(list, materialId = 0) {
    let materialIndex = null;
    list.materials.forEach((s, i) => {
      if(s.relatedContentId == materialId) {
        materialIndex = i;
      }
    });
    if(materialIndex !== null) {
      list.materials.splice(materialIndex, 1);
    } else {
      if(list.nodes.length > 0) {
        list.nodes.forEach(node => {
          this.removeCourseMaterial(node , materialId);
        });
      }
    }
    return list;
  }

  removeCourseMaterialList(list, materialId = 0) {
    let materialIndex = null;
    list.forEach((s, i) => {
      if(s.relatedContentId == materialId) {
        materialIndex = i;
      }
    });
    if(materialIndex !== null) {
      list.splice(materialIndex, 1);
    } else if (list.length > 0) {
      list.forEach(material => {
        if(material.materialsList.length > 0)
          this.removeCourseMaterialList(material.materialsList , materialId);
      });
    }
    return list;
  }

  removeCourseMaterialSection(materials , sectionId) {
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach((sec, index) => {
        if(sec.sectionId == sectionId) {
          sections.splice(index , 1 );
        } else {
          findSectionsMaterial(sec.nodes , sectionId);
        }
      });
    }
    findSectionsMaterial(materials.nodes , sectionId);
    return materials;
  }  

  removeCourseMaterialListSection(materialsList , sectionId) {
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach((sec, index) => {
        if(sec.sectionId == sectionId) {
          sections.splice(index , 1 );
        } else {
          if (sec.materialsList.length > 0)
            findSectionsMaterial(sec.materialsList , sectionId);
        }
      });
    }
    findSectionsMaterial(materialsList , sectionId);
    return materialsList;
  }
  
  getSectionsIdsByMaterialId(sections = [], materialId) {
    let sectionIds = [];
    function findSectionsMaterial(sections = [], materialId) {
      sections.forEach(sec => {
        if(sec.sectionMaterial ? sec.sectionMaterial.materialId == materialId : false) {
          if(sec.type.startsWith('SPLIT')) {
            sectionIds.includes(sec.parentId) ? null : sectionIds.push(sec.parentId);
          } else {
            sectionIds.push(sec.sectionId);
          }
        } else if(sec.sections.length > 0) {
          findSectionsMaterial(sec.sections, materialId);
        }
      });
    }
    findSectionsMaterial(sections , materialId);
    return sectionIds;
  }

  findCurrentCourseMaterial(materials , materialId) {
    let result = null;
    function findByID(materials , materialId) {
      let currentMaterial = materials.materials.find( material =>  material.relatedContentId === materialId);
      if(currentMaterial) {
        result = currentMaterial;
      } else {
        if(materials.nodes.length > 0) {
        materials.nodes.forEach( sec => {
             findByID(sec , materialId );
          });        
        }    
      }
    }
    findByID(materials , materialId);
    return result;
  }

  checkCourseMaterials(materials) {
    let result = false;
    function findCourseMaterials(materials) {
      if(materials.materials.length > 0) {
        result = true;
      } else {
        if(materials.nodes.length > 0) {
          materials.nodes.forEach( sec => {
            findCourseMaterials(sec);
          });
        }
      }
    }
    findCourseMaterials(materials);
    return result;
  } 

  removeCourseMaterialOption(state , materialId) {
    let materialIndex = state.materialsOptionsUsed.indexOf(materialId);
    state.materialsOptionsUsed.splice(materialIndex, 1);
    return state.materialsOptionsUsed;
  }

  getCourseMaterialsRelated(sections = [], materialId) {
    let result = false;
    function findSectionsMaterial(sections = [], materialId) {
      sections.forEach(sec => {
        if(sec.sectionMaterial ? sec.sectionMaterial.materialId == materialId : false) {
          result = true;
        } else if(sec.sections.length > 0) {
          findSectionsMaterial(sec.sections, materialId);
        }
      });
    }
    findSectionsMaterial(sections , materialId);
    return result;
  }

  getSectionMaterialFromId(sections = [], sectionId){
    let section = null;
    if(sectionId == undefined || sectionId == null)
      return section;
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach(sec=>{
        if(sec.sectionId == sectionId){
          section = sec;
          return;
        }
        if(sec.nodes.length > 0){
          findSectionsMaterial(sec.nodes,sectionId);
        }
      });
    }
    findSectionsMaterial(sections,sectionId);
    return section;
  }

  getSectionMaterialListFromId(sections = [], sectionId){
    let section = null;
    if(sectionId == undefined || sectionId == null)
      return section;
    function findSectionsMaterial(sections = [], sectionId) {
      sections.forEach(sec=>{
        if(sec.sectionId == sectionId){
          section = sec;
          return;
        }
        if(sec.materialsList.length > 0){
          findSectionsMaterial(sec.materialsList,sectionId);
        }
      });
    }
    findSectionsMaterial(sections,sectionId);
    return section;
  }

  setMaterialsListContent({materialsList, parentId = 0 , courseId , classId = null}) {
    return materialsList.map(item => {
      if(item.materials && item.nodes) {
        let materialsList = item.materials.concat(item.nodes);
        return {...item, classId , courseId, 
        materialsList: this.setMaterialsListContent({materialsList, parentId: item.id , courseId , classId}) };
      } else {
        return {...item, classId , courseId, materialsList: [], parentId };
      }
    });
  }

  addGradingDetails({sections = [], detail , courseId , classId}) {

      return sections.map(s => {
        if(s.id == detail.sectionId) {
          return {...s, gradingDetails: detail.gradingDetails};
        } else if(s.sections.length > 0) {
          return {...s, sections: this.addGradingDetails({sections: s.sections, 
          detail , courseId , classId})};
        }
        return {...s};
      }); 
    
  }
  
}

export const SectionsProvider = new SectionProvider();
